import isEmpty from 'lodash/isEmpty';
import * as api from '../api/adapters/json_api';
import get from 'lodash/get'

const type = 'invoices'
const path = `api_resources/${type}`;

const sortOptions = (sort) => (!sort || isEmpty(sort.field)) ?
  '-issued_at' :
  `${ sort.direction === 'asc' ? '' : '-' }${ sort.field }`;

const searchOptions = (search) => isEmpty(search) ? null : { search };

export default {
  /**
   * FIN-1244: the invoices block of the Dashboard's Fleet section,
   * GET /api_resources/invoices/dashboard_fleet. No vessels means every vessel the user
   * may see; direction is 'incoming' (the default) or 'outgoing'.
   * @returns {Promise<Object>} the section, as the backend's `data`
   */
  dashboardFleet: ({ vesselIds, direction } = {}) => api
    .read({ type: path, id: 'dashboard_fleet' }, { query: { vessel_ids: vesselIds, direction } })
    .then((response) => response.data.data),

  /**
   * FIN-1240: the Invoices block of the Dashboard's Company section — the receivables and
   * payables of the group's own companies, GET /api_resources/invoices/dashboard_company.
   * @returns {Promise<Object>} the block, as the backend's `data`
   */
  dashboardCompany: () => api
    .read({ type: path, id: 'dashboard_company' }, {})
    .then((response) => response.data.data),

  /**
   * getPaymentInstruction
   * @returns {Promise<*>}
   */
  show: (id) => api.read({ type, id }, {}),

  indexCommon: (pagination, sort, filter) => api.read({ type: path }, {
  query: {
    sort: sortOptions(sort),
    page: { size: pagination.itemsPerPage, number: pagination.activePage },
    filter: filter
  }
}),


  index: (pagination, sort, search, filter, settings, options = {fields: null}) => {
    return api.read({ type: path }, {
      query: {
        sort: sortOptions(sort),
        page: { size: pagination.itemsPerPage, number: pagination.activePage },
        filter: {
          ...filter,
          ...searchOptions(search),
          year: get(settings, 'invoices.budgetYear'),
          period_type: get(settings, 'invoices.periodType'),
          company_id: filter.company_id || (get(settings, 'global.invCompanies') || []).join(','),
          direction: get(settings, 'invoices.direction')
        },
        fields: options.fields
      }
    })
  },
  /**
   * createPaymentInstruction
   * @param attributes
   * @returns {Promise<*>}
   */
  create: (attributes) => api.create(
    { type: path },
    {},
    {
      data: {
        type,
        attributes
      }
    }),
  /**
   * updatePaymentInstruction
   * @param id
   * @param attributes
   * @returns {Promise<*>}
   */
  update: (id, attributes) => api.update(
    { id, type: path },
    {},
    {
      data: {
        id,
        type,
        attributes
      }
    }),
  /**
   * deletePaymentInstruction
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: path }),

  // FIN-1266: what the recurring generator wrote on this invoice — whether it
  // still awaits confirmation, and which template and period it belongs to.
  // Asked through JSON:API because the form itself is fed by GraphQL, which is
  // not extended any more.
  recurringInfo: (id) => api.read({ type: path, id }, {
    query: { fields: { [type]: 'pending_confirmation,recurring' } },
  }),

  // FIN-1266: accounting confirms a generated invoice; it is numbered on the way.
  confirm: (id) => api.create({ type: path, id, action: 'confirm' }, {}, {}),
}
